import { useState } from 'react'
import { OTPInput, REGEXP_ONLY_DIGITS } from 'input-otp'
import { Button, UserHelp } from '@imedcl/design-system'
import { useCountdown } from '../../hooks/useCountdown'
import { Slot } from './Slot'
import { secondsToMinutes } from '../../helpers/setcondsToMinutes'
import { CheckIcon } from '../Icons/CheckIcon'
import { Annulment } from '../Icons/Anullment'
import { errDictionaty } from '../../helpers/dictionary'

export const SecondStep = ({
  onSubmit,
  error,
  loading,
  loadingVerify,
  onResendMessage,
}) => {
  const [otp, setOtp] = useState('')

  const { count, resetCountdown } = useCountdown(300)

  const onNewCode = async () => {
    await onResendMessage()
    setOtp('')
    resetCountdown()
  }

  return (
    <div>
      <p className='text-neutral-60 text-base text-center leading-6 font-medium mb-7 mx-auto w-[328px]'>
        Ingresa el código de validación:
      </p>
      <OTPInput
        maxLength={4}
        inputMode='numeric'
        pattern={REGEXP_ONLY_DIGITS}
        render={({ slots }) => (
          <div className='flex items-center justify-center gap-4'>
            {slots.map((slot, idx) => (
              <Slot key={idx} slotProps={slot} error={error} />
            ))}
          </div>
        )}
        onChange={setOtp}
        value={otp}
      />

      {!error && (
        <div className='mt-10'>
          <p className='text-center text-primary-imed-60 text-2xl leading-8 mb-10 font-semibold'>
            {secondsToMinutes(count)} min
          </p>
          <div className='px-[102px] mx-auto'>
            <Button
              buttonType='submit'
              type='secondary'
              className='w-full mx-0 mb-4'
              disabled={loading || loadingVerify || !otp || otp.length < 4}
              loading={loadingVerify}
              onClick={() => onSubmit(otp)}>
              Validar código
            </Button>
            <div className='w-full border border-[#092F6D] rounded'>
              <Button
                buttonType='button'
                type='ghost-primary'
                className='w-full mx-0'
                onClick={onNewCode}
                disabled={loading || loadingVerify}>
                Solicitar nuevo código
              </Button>
            </div>
          </div>
          <div className='mt-6'>
            <UserHelp
              colorStyle='success'
              icon={<CheckIcon />}
              customText={
                <p className='font-normal text-sm leading-6 text-primary-imed-70 w-full'>
                  <span className='font-semibold'>
                    El mensaje fue enviado con éxito a tu email.
                  </span>{' '}
                  Este código es válido sólo para esta operación.
                  <span className='font-semibold'>
                    {' '}
                    Tienes 05:00 para ingresarlo.
                  </span>{' '}
                  Luego de ese tiempo, deberás solicitarlo de nuevo.
                </p>
              }
            />
          </div>
        </div>
      )}

      {error && (
        <div className='mt-10'>
          <Annulment
            customHeight='56'
            customWidth='56'
            svgClass='mx-auto mb-3'
            pathClass='stroke-error-dark'
          />
          <p className='text-base font-normal leading-6 text-center text-error-dark w-[326px] mx-auto'>
            {errDictionaty[error] ?? error ?? 'Error en MFA'}
          </p>
          <div className='px-[102px] mx-auto mt-10'>
            <Button
              buttonType='submit'
              type='secondary'
              className='w-full mx-0 mb-4'
              disabled={loading || loadingVerify || !otp || otp.length < 4}
              loading={loadingVerify}
              onClick={() => onSubmit(otp)}>
              Validar código
            </Button>
            <div className='w-full border border-[#092F6D] rounded'>
              <Button
                buttonType='button'
                type='ghost-primary'
                className='w-full mx-0'
                onClick={onNewCode}
                disabled={loading || loadingVerify}>
                Solicitar nuevo código
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
